import HelperService from "../services/helper-service";
import {UserRepresentativeLink, UserRepresentativeMandate} from "../utils/constants";

export default function UserRepresentativeCell({ userRepresentative, edit, del, onSuccess, className, ...props}) {
  return (
    <>
      {userRepresentative &&
        <div className={"d-flex justify-content-between align-items-center bg-light-lighten p-2 rounded gap-2 mb-2 "+className}>
          <div>
          <span className="me-2">
            <span className="dripicons-user-group"></span>
          </span>
            <strong>{userRepresentative.representative?.name}</strong>
            <div>{HelperService.getObjByKey(Object.values(UserRepresentativeLink), 'val', userRepresentative.link_type)?.title}</div>
            <div>{HelperService.getObjByKey(Object.values(UserRepresentativeMandate), 'val', userRepresentative.mandate_type)?.title}</div>
            {userRepresentative.is_temporary && <div>{HelperService.formatDate(userRepresentative.starts_at)} - {HelperService.formatDate(userRepresentative.ends_at)}</div>}
            {userRepresentative.share && <div className="badge bg-primary">{userRepresentative.share}%</div>}
          </div>
          {(edit||del) && <div className={"d-inline-flex"}>
            {edit && <button type="button" className="btn btn-sm btn-circle btn-light hover-text-primary ms-1" onClick={()=>edit(userRepresentative)}><span className="mdi mdi-pencil" title="Upraviť"></span></button>}
            {del && <button type="button" className="btn btn-sm btn-circle btn-light hover-text-danger ms-1" onClick={()=>del(userRepresentative)}><span className="mdi mdi-trash-can" title="Zmazať"></span></button>}
          </div>}
        </div>
      }
    </>
  );
}
